import { isLocalhost } from "./isLocalhost";
export const isInProductionMode = !isLocalhost;
